import React, { useState } from 'react'
import classnames from 'classnames'

const INITIAL_STATE = 320
// const PANEL_WIDTH_KEY = '@sharethis/data-explorer/panel-width'

const useColResize = ({ min, max, containerRef }) => {
  const [isResizing, setIsResizing] = useState(false)
  const [panelWidth, setPanelWidth] = useState(min || INITIAL_STATE)
  const [isCollapsed, setIsCollapsed] = useState(false)

  const handleOpenPanel = () => {
    setPanelWidth(INITIAL_STATE)
    setIsCollapsed(false)
  }

  const handleClosePanel = () => {
    setIsCollapsed(true)
  }

  const handleMouseMove = ({ pageX }) => {
    const { left } = containerRef.current.getBoundingClientRect()
    const position = pageX - left

    if (isResizing) {
      if (position + 4 <= min) {
        setPanelWidth(min)
        return
      }

      if (position + 4 >= min && isCollapsed) {
        setIsCollapsed(false)
      }

      if (position + 4 >= max) {
        return
      }

      setPanelWidth(position + 4)
    }
  }

  const handleMouseDown = (event) => {
    event.stopPropagation()
    event.preventDefault()
    setIsResizing(true)
  }

  const handleMouseUp = () => {
    setIsResizing(false)
  }

  const Divider = ({ className }) => {
    return (
      <div className={classnames(className, { hover: isResizing })} onMouseDown={handleMouseDown}>
        &nbsp;
      </div>
    )
  }

  return {
    Divider,
    handleMouseUp,
    handleMouseMove,
    handleOpenPanel,
    handleClosePanel,
    isResizing,
    panelWidth,
    isCollapsed,
  }
}

export default useColResize
